import { SupabaseClient } from '@supabase/supabase-js';
import { RecipeComment } from '../api/Types';
import { COMMENT_WITH_AUTHOR_SELECT } from './serviceSelectors';

const throwIfQueryFailed = (error: { message?: string } | null): void => {
  if (error) {
    throw new Error(error.message);
  }
};

export const listCommentsByRecipeId = async (
  supabaseClient: SupabaseClient,
  recipeId: string
): Promise<RecipeComment[]> => {
  const { data, error } = await supabaseClient
    .from('comments')
    .select(COMMENT_WITH_AUTHOR_SELECT)
    .eq('recipe_id', recipeId)
    .order('created_at', { ascending: true });

  throwIfQueryFailed(error);

  return ((data || []) as unknown) as RecipeComment[];
};

export const getCommentRecordById = async (
  supabaseClient: SupabaseClient,
  commentId: number
): Promise<RecipeComment | null> => {
  const { data, error } = await supabaseClient
    .from('comments')
    .select(COMMENT_WITH_AUTHOR_SELECT)
    .eq('id', commentId)
    .single();

  throwIfQueryFailed(error);

  if (!data) {
    return null;
  }

  return (data as unknown) as RecipeComment;
};

export const insertCommentRecord = async (
  supabaseClient: SupabaseClient,
  commentData: { recipe_id: string; author_id: number; comment: string; }
): Promise<RecipeComment> => {
  const { data, error } = await supabaseClient
    .from('comments')
    .insert(commentData)
    .select(COMMENT_WITH_AUTHOR_SELECT)
    .single();

  throwIfQueryFailed(error);

  if (!data) {
    throw new Error('Comment creation returned no data.');
  }

  return (data as unknown) as RecipeComment;
};

export const updateCommentRecord = async (
  supabaseClient: SupabaseClient,
  commentId: number,
  comment: string
): Promise<RecipeComment> => {
  const { data, error } = await supabaseClient
    .from('comments')
    .update({ comment })
    .eq('id', commentId)
    .select(COMMENT_WITH_AUTHOR_SELECT)
    .single();

  throwIfQueryFailed(error);

  if (!data) {
    throw new Error('Comment update returned no data.');
  }

  return (data as unknown) as RecipeComment;
};

export const deleteCommentRecord = async (
  supabaseClient: SupabaseClient,
  commentId: number
): Promise<void> => {
  const { error } = await supabaseClient.from('comments').delete().eq('id', commentId);

  throwIfQueryFailed(error);
};
